import Vue from 'vue'
import Router from 'vue-router'
import user from '@/pages/user'
import login from '@/pages/login'
import scanCode from '@/pages/scanCode'
import password from '@/pages/password'
import order from '@/pages/order'
import deatil from '@/pages/deatil'
import bindBalanceMsg from '@/pages/bindBalanceMsg'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:"登录"}
    },
    {
      path: '/scanCode',
      name: 'scanCode',
      component: scanCode,
      meta:{title:"扫码核销"}
    },
    {
      path: '/bindBalanceMsg',
      name: 'bindBalanceMsg',
      component: bindBalanceMsg,
      meta:{title:"余额通知绑定"}
    },
    {
      path: '/order/:status?',
      name: 'order',
      component: order,
      meta:{title:"订单列表"}
    },
    {
      path: '/deatil/:id',
      name: 'deatil',
      component: deatil,
      meta:{title:"订单详情"}
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{title:"个人中心"}
    },
    {
      path: '/password',
      name: 'password',
      component: password,
      meta:{title:"修改密码"}
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js